// extracted by mini-css-extract-plugin
export default {"loader-wrapper":"_1pqur1l","loaderWrapper":"_1pqur1l","font-upgrade":"_1t83v3i","fontUpgrade":"_1t83v3i"};